import CustomModal from "../../../../../components/Modal/CustomModal";
import {
    EmailSubsectionChip,
    IconBannerAttendance, IconEntryDevice, IconExitDevice,
    IconPeronClock, MarkerTitle, OutlinedCalendarIcon,
    PersonChipBlack, PhoneSubsectionChip
} from "../../../../../components/buttons/IconButtons";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {Divider} from "@mui/material";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, errorMsg, getDateFormat} from "../../../../../Apis/functions";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomUserChip from "../../../../../components/CustomUserChip";
import AccessMethodIcon from "../../../../../components/icons/AccessMethodIcon";
import {ATTENDANCE_COLOR_MODEL, ATTENDANCE_STATUS_COLOR_MODEL, SUFFIX_COLOR_TEXT} from "../Model/Model";
import {useEffect, useState} from "react";
import {GetAllLastEntryByUser} from "../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi";
import {GetAttendanceColor} from "../../../../../reduxToolkit/AttendanceConfig/AttendanceConfigApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendanceDetailModal = (props) => {
    const {
        onHide,
        t,
        id,
        dispatch,
        attendanceEmployee,
        setAttendanceEmployee
    } = props;
    const [color, setColor] = useState({...ATTENDANCE_COLOR_MODEL.setDefaultData()});

    useEffect(()=>{
        if(id !== null && typeof id !== "undefined"){
            dispatch(GetAllLastEntryByUser({params: {id : id , total : 5}})).then(({ payload: { data: { data, success, code }}})=>{
                if(success){
                    const attendances = data;
                    dispatch(GetAttendanceColor()).then(({payload: {data: { data }}}) => {
                        setColor({ ...ATTENDANCE_COLOR_MODEL, ...data });
                        setAttendanceEmployee(attendances)
                    });
                } else errorMsg(code)
            })
        }
    },[id])

    return (
        <>
            <CustomModal
                {...props}
                size='md'
                buttonConfirm='confirm'
                onHide={() => {
                    onHide();
                }}
                confirmButton={false}
                cancelButton={false}
                classNameBody={'my-0'}
                topLeftHeader={
                    <div className={"d-flex"}>
                        <IconPeronClock/>
                        <p className={"fs-modal-title font-color-general-950 ml-2 pt-5px"}>{t("attendance_details")}</p>
                    </div>
                }
            >
                <div className={"border-radius-8px border-full-shades-100 gap-1"}>
                    <IconBannerAttendance className={"w-100 m-0 p-0"}/>
                    <div className={"d-flex py-3 px-3 border-bottom-shades-300"}>
                        <PersonChipBlack className={"btn-icon-svg-32px"}/>
                        <p className={"fs-14px ibl-font-w-400 font-color-general-950 ml-2 pt-5px ext-capitalize"}>{t(attendanceEmployee?.name)}</p>
                        <Divider className={"mx-1"}/>
                    </div>
                    <CustomGenericTittleIconDataChip className={'p-3'} border={true} title={t("email_telephone")}/>
                    <div className={"d-flex justify-content-start align-items-center gap-2 px-3 "}>
                        <div>
                            <EmailSubsectionChip className={'btn-icon-svg-16px'}/>
                        </div>
                        <p className={"fs-14px ibl-font-w-400 font-color-general-950"}>{attendanceEmployee?.email}</p>
                    </div>
                    <div className={"d-flex justify-content-start align-items-center gap-2 px-3 mt-12px"}>
                        <div>
                            <PhoneSubsectionChip className={"btn-icon-svg-16px"}/>
                        </div>
                        <p className={"fs-14px ibl-font-w-400 font-color-general-950"}>{attendanceEmployee?.phoneNumber || EMPTY_VALUES.DEFAULT}</p>
                    </div>
                    <CustomGenericTittleIconDataChip className={'p-3'} border={true} title={t("last_x_days",{number:5})}/>
                    <div className={"row gap-3 pb-3"}>
                        { attendanceEmployee?.attendances?.map((item) => {
                            const statusEntryKey = ATTENDANCE_STATUS_COLOR_MODEL[item.entryDateStatus];
                            const statusEntryBackground = color[statusEntryKey];
                            const statusEntryColorText = color[statusEntryKey + SUFFIX_COLOR_TEXT];

                            const statusExitKey = ATTENDANCE_STATUS_COLOR_MODEL[item.exitDateStatus];
                            const statusExitBackground = color[statusExitKey];
                            const statusExitColorText = color[statusExitKey + SUFFIX_COLOR_TEXT];

                            return (
                                <div className={"row col-12"}>
                                    <div className={"col-6 my-1"}>
                                        <div className={"d-flex gap-2 align-items-center"}>
                                            <div className={"d-flex"}>
                                                <OutlinedCalendarIcon className={'btn-icon-svg-16px'}/>
                                            </div>
                                            <p className={"fs-14px ibl-font-w-400 font-color-general-950 text-capitalize"}>{item?.day}</p>
                                        </div>
                                        <div className={"d-flex gap-2 justify-content-center align-items-center mt-2"}>
                                            <div className={"d-flex"}>
                                                <AccessMethodIcon AccessMethodId={item?.entryAccessMethodId} />
                                            </div>
                                            <CustomUserChip
                                                className={`mt-0`}
                                                name={item.entryDate === null ? t('no_record') : getDateFormat(item?.entryDate,false, DATE_TIME_FORMAT_NAME_MODEL.HHmm)}
                                                showAvatar={true}
                                                Icon={IconEntryDevice}
                                                classNameIcon={`p-0 mt-0`}
                                                classNameText={'ibl-font-w-600 p-0'}
                                                variant="large"
                                                iconPosition={POSITION_MODEL.RIGHT}
                                                sx={{
                                                    backgroundColor: statusEntryBackground,
                                                    borderColor: statusEntryBackground,
                                                    '&:hover': {
                                                        backgroundColor: statusEntryBackground,
                                                        borderColor: statusEntryBackground,
                                                    }
                                                }}
                                                textSx={{
                                                    color: statusEntryColorText
                                                }}
                                                iconStyle={{
                                                    fill: statusEntryColorText
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-6 my-1"}>
                                        <div className={"d-flex gap-2 align-items-center"}>
                                            <div className={"d-flex"}>
                                                <MarkerTitle className={'btn-icon-svg-16px'}/>
                                            </div>
                                            <p className={"fs-14px ibl-font-w-400 font-color-general-950 text-capitalize"}>{item?.entryZoneName}</p>
                                        </div>
                                        <div className={"d-flex gap-2 justify-content-center align-items-center mt-2"}>
                                            <div className={"d-flex"}>
                                                <AccessMethodIcon AccessMethodId={item?.exitAccessMethodId} />
                                            </div>

                                            <CustomUserChip
                                                className={`mt-0`}
                                                name={item.exitDate === null ? t('no_record') : getDateFormat(item.exitDate,false, DATE_TIME_FORMAT_NAME_MODEL.HHmm)}
                                                showAvatar={true}
                                                Icon={IconExitDevice}
                                                classNameIcon={`p-0 mt-0`}
                                                classNameText={'ibl-font-w-600 p-0'}
                                                variant="large"
                                                iconPosition={POSITION_MODEL.RIGHT}
                                                sx={{
                                                    backgroundColor: statusExitBackground,
                                                    borderColor: statusExitBackground,
                                                    '&:hover': {
                                                        backgroundColor: statusExitBackground,
                                                        borderColor: statusExitBackground,
                                                    }
                                                }}
                                                textSx={{
                                                    color: statusExitColorText
                                                }}
                                                iconStyle={{
                                                    fill: statusExitColorText
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </div>

            </CustomModal>
        </>
    )
}

export default AttendanceDetailModal
